import axiosInstance from "./AxiosInstance";
import queryString from "query-string";
import config from "../config";

const { apiAppendPath } = config;

export const getTickets = (filterData) => {
  return axiosInstance.get(
    `${apiAppendPath.caseTicketsAppendPath}`,
    { params: filterData }
  );
};

export const updateTicket = (data) => {
  return axiosInstance.put(
    `${apiAppendPath.caseTicketsAppendPath}/update-ticket`,
    data
  );
};

export const getUnreadTicketsCount = () => {
  return axiosInstance.get(
    `${apiAppendPath.caseTicketsAppendPath}?unread-count=true`
  );
};

export const getUnreadMessagesCountByTicketIds = (ticketIds) => {
  return axiosInstance.get(
    `${apiAppendPath.caseTicketsAppendPath}/unread-messages-count-by-ticket-ids`,
    {
      params: { ticketIds },
      paramsSerializer: (params) => queryString.stringify(params, { arrayFormat: "repeat" }),
    }
  );
}

export const getCaseTicketClearNotification = (ticketId) => {
  return axiosInstance.get(
    `${apiAppendPath.caseTicketsAppendPath}/clear-ticket-notifications`,
    { params: ticketId }
  );
};
export const markTicketAsRead = (ticketId) => {
  return axiosInstance.put(
    `${apiAppendPath.caseTicketsAppendPath}/mark-ticket-as-read`,
    { ticketId }
  );
};

export const getTicketChat = (params) => {
  return axiosInstance.get(
    `${apiAppendPath.caseTicketsAppendPath}/fetch-chat-ticket`,
    { params }
  );
};

export const sendChatMessage = (data) => {
  return axiosInstance.post(
    `${apiAppendPath.caseTicketsAppendPath}/chat-ticket`,
    data
  );
};

export const getActiveAdminUsers = () => {
  return axiosInstance.get(
    `${apiAppendPath.userTypeApiAppendPath}/admin-user?status=active&active=true`
  );
};

export const getTicketByCaseId = (caseId) => {
  return axiosInstance.get(
    `${apiAppendPath.caseTicketsAppendPath}/get-ticket-by-case-id/${caseId}`
  );
};


const TicketApi = {
  getTickets,
  updateTicket,
  getUnreadTicketsCount,
  getCaseTicketClearNotification,
  getUnreadMessagesCountByTicketIds,
  markTicketAsRead,
  getTicketChat,
  sendChatMessage,
  getActiveAdminUsers,
};

export default TicketApi;
